// Breadcrumb identifiers
const customerBreadcrumbIdentifier = {
    route: 'customers.customers.show',
    parameterLabel: 'customer',
    parameters: ['customer']
}
const customerContactBreadcrumbIdentifier = {
    route: 'customers.customers.contacts.show',
    parameterLabel: 'contact',
    parameters: ['customer', 'contact']
}
const customerContractBreadcrumbIdentifier = {
    route: 'customers.customers.contracts.show',
    parameterLabel: 'contract',
    parameters: ['customer', 'contract']
}
const customerContractPhaseBreadcrumbIdentifier = {
    route: 'customers.customers.contracts.phases.edit',
    parameterLabel: 'phase',
    parameters: ['customer', 'contract', 'phase']
}
const customerInvoiceBreadcrumbIdentifier = {
    route: 'customers.customers.invoices.show',
    parameterLabel: 'invoice',
    parameters: ['customer', 'invoice']
}
const customerCreditNoteBreadcrumbIdentifier = {
    route: 'customers.customers.credit-notes.show',
    parameterLabel: 'credit_note',
    parameters: ['customer', 'credit_note']
}
const customerNoteBreadcrumbIdentifier = {
    route: 'customers.customers.customer-notes.edit',
    parameterLabel: 'customer_note',
    parameters: ['customer', 'customer_note']
}
const customerResellerBreadcrumbIdentifier = {
    route: 'customers.customers.reseller-products.edit',
    parameterLabel: 'reseller_product',
    parameters: ['customer', 'reseller_product']
}
const customerFileBreadcrumbIdentifier = {
    route: 'customers.customers.customer-files.edit',
    parameterLabel: 'customer_file',
    parameters: ['customer', 'customer_file']
}
const customerIncidentBreadcrumbIdentifier = {
    route: 'customers.customers.business-incidents.edit',
    parameterLabel: 'business_incident',
    parameters: ['customer', 'business_incident']
}
const customerIncidentIndexBreadcrumbIdentifier = {
    route: 'customers.customers.business-incidents.index',
    parameterLabel: 'customer',
    parameters: ['customer']
}

export default [
    {
        route: 'customers.customers.index',
        label: 'messages.sitemap.customers.index',
        showInSidebar: true,
        permissions: ['customer.view'],
        id: 'customers-index',
        children: [
            {
                route: 'customers.customers.show',
                label: 'messages.sitemap.customers.show',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.advanced-search.index',
                label: 'messages.sitemap.customers.advanced-search.index'
            },
            {
                route: 'customers.customers.advanced-search.show',
                label: 'messages.sitemap.customers.advanced-search.show'
            },
            {
                route: 'customers.customers.edit',
                label: 'messages.sitemap.customers.edit',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.contacts.index',
                label: 'messages.sitemap.customers.contacts.contacts',
                identifier: customerBreadcrumbIdentifier,
                children: [
                    {
                        route: 'customers.customers.contacts.create',
                        label: 'messages.sitemap.customers.contacts.create'
                    },
                    {
                        route: 'customers.customers.contacts.edit',
                        label: 'messages.sitemap.customers.contacts.edit',
                        identifier: customerContactBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.contacts.show',
                        label: 'messages.sitemap.customers.contacts.show',
                        identifier: customerContactBreadcrumbIdentifier
                    }
                ]
            },
            {
                route: 'customers.customers.contracts.index',
                label: 'messages.sitemap.customers.contracts.contracts',
                identifier: customerBreadcrumbIdentifier,
                children: [
                    {
                        route: 'customers.customers.contracts.show',
                        label: 'messages.sitemap.customers.contracts.show',
                        identifier: customerContractBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.contracts.reseller_contracts',
                        label: 'messages.sitemap.customers.contracts.reseller_contracts',
                        identifier: customerContractBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.contracts.partner_contracts',
                        label: 'messages.sitemap.customers.contracts.partner_contracts',
                        identifier: customerContractBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.contracts.providerbox_contracts',
                        label: 'messages.sitemap.customers.contracts.providerbox_contracts',
                        identifier: customerContractBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.contracts.create',
                        label: 'messages.sitemap.customers.contracts.create'
                    },
                    {
                        route: 'customers.customers.contracts.create-contract-tree',
                        label: 'messages.sitemap.customers.contracts.create_contract_tree'
                    },
                    {
                        route: 'customers.customers.contracts.edit',
                        label: 'messages.sitemap.customers.contracts.edit',
                        identifier: customerContractBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.contracts.track-suspension',
                        label: 'messages.sitemap.customers.contracts.track_suspension',
                        identifier: customerContractBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.contracts.phases.index',
                        label: 'messages.sitemap.customers.contracts.phases.phases',
                        identifier: customerContractBreadcrumbIdentifier,
                        children: [
                            {
                                route: 'customers.customers.contracts.phases.create',
                                label: 'messages.sitemap.customers.contracts.phases.create'
                            },
                            {
                                route: 'customers.customers.contracts.phases.edit',
                                label: 'messages.sitemap.customers.contracts.phases.edit',
                                identifier: customerContractPhaseBreadcrumbIdentifier
                            }
                        ]
                    }
                ]
            },
            {
                route: 'customers.customers.invoices.index',
                label: 'messages.sitemap.customers.invoices.invoices',
                identifier: customerBreadcrumbIdentifier,
                children: [
                    {
                        route: 'customers.customers.invoices.show',
                        label: 'messages.sitemap.customers.invoices.show',
                        identifier: customerInvoiceBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.credit-notes.show',
                        label: 'messages.sitemap.customers.credit_notes.show',
                        identifier: customerCreditNoteBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.credit-notes.create',
                        label: 'messages.sitemap.customers.credit_notes.create'
                    },
                    {
                        route: 'customers.customers.invoices.create',
                        label: 'messages.sitemap.customers.invoices.create'
                    },
                    {
                        route: 'customers.customers.invoices.items',
                        label: 'messages.sitemap.customers.invoices.items',
                        identifier: customerInvoiceBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.invoices.items-list',
                        label: 'messages.sitemap.customers.invoices.items_list',
                        identifier: customerInvoiceBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.credit-notes.items-list',
                        label: 'messages.sitemap.customers.credit_notes.items_list',
                        identifier: customerCreditNoteBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.invoices.pending-invoice-items',
                        label: 'messages.sitemap.customers.invoices.pending_invoice_items',
                    },
                ]
            },
            {
                route: 'customers.customers.communications.index',
                label: 'messages.sitemap.customers.communications.communications',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.communications.messenger.index',
                label: 'messages.sitemap.customers.communications.messenger',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.customer-notes.index',
                label: 'messages.sitemap.customers.customer_notes.customer_notes',
                identifier: customerBreadcrumbIdentifier,
                children: [
                    {
                        route: 'customers.customers.customer-notes.create',
                        label: 'messages.sitemap.customers.customer_notes.create'
                    },
                    {
                        route: 'customers.customers.customer-notes.edit',
                        label: 'messages.sitemap.customers.customer_notes.edit',
                        identifier: customerNoteBreadcrumbIdentifier
                    }
                ]
            },
            {
                route: 'customers.customers.activity-logs.index',
                label: 'messages.sitemap.customers.activity_logs.activity_logs',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.reseller-products.index',
                label: 'messages.sitemap.customers.reseller_products.reseller_products',
                identifier: customerBreadcrumbIdentifier,
                children: [
                    {
                        route: 'customers.customers.reseller-products.create',
                        label: 'messages.sitemap.customers.reseller_products.create'
                    },
                    {
                        route: 'customers.customers.reseller-products.edit',
                        label: 'messages.sitemap.customers.reseller_products.edit',
                        identifier: customerResellerBreadcrumbIdentifier
                    }
                ]
            },
            {
                route: 'customers.customers.customer-files.index',
                label: 'messages.sitemap.customers.customer_files.customer_files',
                identifier: customerBreadcrumbIdentifier,
                children: [
                    {
                        route: 'customers.customers.customer-files.create',
                        label: 'messages.sitemap.customers.customer_files.create'
                    },
                    {
                        route: 'customers.customers.customer-files.edit',
                        label: 'messages.sitemap.customers.customer_files.edit',
                        identifier: customerFileBreadcrumbIdentifier
                    }
                ]
            },
            {
                route: 'customers.customers.upload-dpa.create',
                label: 'messages.sitemap.customers.upload_dpa.upload_dpa',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.transactions.index',
                label: 'messages.sitemap.customers.transactions.transactions',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.orders.index',
                label: 'messages.sitemap.customers.orders.orders',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.tickets.index',
                label: 'messages.sitemap.customers.tickets.tickets',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.delivery_notes.index',
                label: 'messages.sitemap.customers.delivery_notes.index',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.delivery_notes.create',
                label: 'messages.sitemap.customers.delivery_notes.create',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.business-incidents.index',
                label: 'messages.sitemap.customers.business_incidents.business_incidents',
                identifier: customerBreadcrumbIdentifier,
                children: [
                    {
                        route: 'customers.customers.business-incidents.create',
                        label: 'messages.sitemap.customers.business_incidents.create'
                    },
                    {
                        route: 'customers.customers.business-incidents.edit',
                        label: 'messages.sitemap.customers.business_incidents.edit',
                        identifier: customerIncidentBreadcrumbIdentifier
                    },
                    {
                        route: 'customers.customers.business-incidents.create',
                        label: 'messages.sitemap.customers.business_incidents.edit',
                        identifier: customerIncidentIndexBreadcrumbIdentifier
                    }
                ]
            },
            {
                route: 'customers.customers.terminate_bankruptcy_contracts',
                label: 'messages.sitemap.customers.terminate_bankruptcy_contracts.terminate_bankruptcy_contracts',
                identifier: customerBreadcrumbIdentifier
            },
            {
                route: 'customers.customers.manage-clusters.index',
                label: 'messages.sitemap.customers.manage_clusters.manage_clusters',
                identifier: customerBreadcrumbIdentifier
            }
        ]
    },
    {
        route: 'customers.customers.create',
        label: 'messages.sitemap.customers.create',
        showInSidebar: true,
        permissions: ['customer.create'],
        id: 'customers-create'
    },
    {
        route: 'customers.all-business-incidents.index',
        label: 'messages.sitemap.customers.all_business_incidents.all_business_incidents',
        showInSidebar: true,
        permissions: ['customer.incidents_view'],
        id: 'all-business-incidents'
    }
]
